module.exports = __webpack_public_path__ + "static/media/4_l_traktor_1.09_67.78.0a3fa732.png";